import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';
import { createUser } from 'src/_shared/api/graphql/custom/users/';
import { updateContact } from '../../graphql/custom/contacts';

export const withNewExtendedUser = (Component, variables) => {
	const id = window.location.pathname.split('/').pop();
	let { host } = window.location;
	host = host.replace('www.', '');
	return compose(
		graphql(gql(createUser), {
			props: (props) => ({
				onCreate(input) {
					return props.mutate({
						context: {
							headers: {
								'x-frame-options': 'deny', // This header will reach the server
							},
						},
						variables: input,
					});
				},
			}),
		}),
		graphql(gql(updateContact), {
			props: (props) => ({
				onUpdateContact(input) {
					return props.mutate({
						context: {
							headers: {
								'x-frame-options': 'deny', // This header will reach the server
							},
						},
						variables: input,
					});
				},
			}),
		})
	)(Component);
};
